const getLocaleFormat = (value, locale) => {
    if (!value) return undefined;
    const currencyLocale = Intl.NumberFormat(locale);
    return currencyLocale.format(value);
};

// Returns a function handler for handling the 'onbeforeunload' event
// If we provide a parameter `enabled = false`, the function returns undefined
// and therefore does not trigger the browser confirmation popup
const getBeforeUnloadHandler = (enabled = true) => {
    return (e) => {
        if (enabled) {
            // For IE and Firefox
            if (e) {
                e.returnValue = '';
            }
            // For Safari
            return '';
        }
        return undefined;
    };
};

// Polyfill for Promise.allSettled to work will all browsers
function allSettled(promises) {
    const wrappedPromises = promises.map((p) =>
        Promise.resolve(p).then(
            (val) => ({ status: 'fulfilled', value: val }),
            (err) => ({ status: 'rejected', reason: err })
        )
    );
    return Promise.all(wrappedPromises);
}

export { getLocaleFormat, getBeforeUnloadHandler, allSettled };
